<template>
    <li v-bind:class="{ soldout: !(event.libres > 0 || event.libres_abonados > 0) }">
        <EventMetadata :event="event" />
        <div class="thumb">
            <img :src="event.imagen" :alt="event.name" />
        </div>
        <div class="content">
            <div>
                <div class="title">
                    {{ event.name }}
                </div>

                <div class="datetime">
                    {{ event.author }}
                </div>

                <div class="datetime">
                    <div v-if="! event.varias_sesiones">
                        <span class="date">{{ event.fecha }}</span>
                        -
                        <span class="time">{{ event.hora }}</span>
                    </div>
                    <span v-else class="time">Varias sesiones</span>
                </div>

                <div class="price" v-if="!url.includes('productos')" :class="{ 'price-hidden': (event.precio_minimo == '0' || event.precio_minimo == 0) && event.enlace_redireccion != null }">
                    {{ $t('eventos.precio_desde') }} 
                    <strong>
                        {{ event.precio_minimo | formatear_precio }}
                        <span v-if="event?.entradas_disponibles && event.entradas_disponibles.some(entrada => entrada.price === event.precio_minimo && entrada.price_management_online !== 0 && entrada.price_management_online_interno === 0)"> + G.G</span>
                    </strong>
                </div>
            </div>

            <footer>
                <div>
                    <div class="row">
                        <div class="col-auto flex-fill my-2 my-lg-3">
                            <span v-if="event.activar_enlace_redireccion">
                                <a class="button w-100" :href="event.enlace_redireccion" target="_blank">
                                    {{ $t('partidos.comprar') }}
                                </a>
                            </span>
                            <template v-else-if="event.status === 2">
                                <button style="background-color: black;" class="button w-100" disabled>
                                    {{ $t('eventos.cancelado') }}
                                </button>
                            </template>
                            <template v-else-if="event.status == 3">
                                <button style="background-color: black;" class="button w-100" disabled>
                                    {{ $t('partidos.aplazado') }}
                                </button>
                            </template>
                            <template v-else-if="mostrarBotonesPreventa">
                                <BotonesPreventa :event="event" :deportes="false" />
                            </template>
                            <button v-else-if="event.entradas_agotadas_online" class="button red-content w-100" disabled>
                                {{ $t('partidos.agotadas') }}
                            </button>
                            <template v-else-if="event.fecha_fin_evento <= fecha_actual || event.fecha_fin_sesion <= fecha_actual">
                                <button class="button blue-content w-100" disabled>
                                    {{ $t('partidos.cerrado_definitivo') }}
                                </button>
                            </template>
                            <template v-else-if="event.venta_online_cerrada && !event.venta_online_cerrada_definitiva">
                                <div class="d-md-flex align-content-center flex-fill">
                                    <button class="button large-button w-100 blue-content mr-3 btn-padding" disabled>
                                        <div class="row">
                                            <div class="col-12 font-prox">
                                                {{ $t('partidos.proximamente') }}
                                            </div>
                                            <div class="col-12 font-prox">
                                                <Countdown v-if="event.cuenta_atras" :endDate="event.cuenta_atras" @close="emitirRecargar"/>
                                            </div>
                                        </div>
                                    </button>
                                    <button
                                        data-cy="btn-avisame"
                                        class="button large-button w-100 green-content mt-md-0 mt-2"
                                        @click="showModal('recordatorio-' + event.id)"
                                    >
                                        {{ $t('partidos.avisame') }}
                                    </button>
                                </div>
                                <RecordatorioModal :evento_id="event.id" @close="closeModal" />
                            </template>
                            <template v-else-if="event.venta_online_cerrada_definitiva">
                                <button class="button blue-content w-100" disabled>
                                    {{ $t('partidos.cerrado_definitivo') }}
                                </button>
                            </template>
                            <template v-else-if="event.libres > 0 || event.libres_abonados > 0 || (event.compartido && event.libres) ||  event.libres_amigo_abonado">
                                <div class="d-md-flex align-content-center flex-fill">
                                    <template v-if="!event.solo_abonados && !event.compartido">
                                        <router-link 
                                            :to="{
                                                name: event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show',
                                                params: {
                                                    event_id: event.id,
                                                    sesion_id: event.sesion_id,
                                                    tipo_venta: 'normal'
                                                },
                                            }"
                                            :data-testid="'comprar-evento-' + event.id"
                                            class="button large-button w-100 mr-3"
                                        >
                                            <span v-if="!tieneGastosInternosOnline && (event.precio_minimo == 0 || event.precio_minimo == null)">
                                                {{ $t('eventos.descargar_invitaciones') }}
                                            </span>
                                            <span v-else>
                                                {{ $t('partidos.comprar') }}
                                            </span>
                                        </router-link>
                                    </template>
                                    <template v-if="event.tiene_descuento_abonado">
                                        <router-link 
                                            :to="{
                                                name: event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados',
                                                params: {
                                                    event_id: event.id,
                                                    sesion_id: event.sesion_id,
                                                    tipo_venta: 'abonados'
                                                }
                                            }" 
                                            class="button large-button w-100 mt-2 mt-md-0"
                                        >
                                            <span>
                                                <small class="d-block">
                                                    {{ $t('partidos.soy_abonado', {abonado: teatro.texto_abonado}) }}
                                                </small>
                                            </span>
                                        </router-link>
                                    </template>
                                    <template v-if="event.amigo_abonado">
                                        <router-link 
                                            :to="{
                                                name: event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.amigosabonados',
                                                params: {
                                                    event_id: event.id,
                                                    sesion_id: event.sesion_id,
                                                    tipo_venta: 'amigosabonados'
                                                }
                                            }" 
                                            :class="'button w-100 ' + (teatro.hash !== 'XSb8uxOmqRUI9fMC3Kos' ? 'large-button mt-2 mt-md-0' : 'red-content disabled')"
                                        >
                                            <span>
                                                <small class="d-block">
                                                    {{ teatro.hash !== 'XSb8uxOmqRUI9fMC3Kos' ? 'Invitaciones' : $t('partidos.agotadas') }}
                                                </small>
                                            </span>
                                        </router-link>
                                    </template>
                                    <template v-if="event.compartido">
                                        <a
                                            :href="event.url_evento" 
                                            class="button large-button w-100"
                                            target="_blank"
                                        >
                                            <span>
                                                {{ $t('partidos.comprar') }}
                                            </span>
                                        </a>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <button
                                    v-if="event.entradas_disponibles && event.entradas_disponibles.length == 0 && event?.entradas_disponibles_abonos.length == 0"
                                    class="button blue-content w-100" 
                                    disabled
                                >
                                    {{ $t('partidos.cerrado_definitivo') }}
                                </button>

                                <button v-else-if="event.sesiones_activas" class="button w-100 p-responsive" disabled>
                                    <h7>{{ $t('eventos.ultimas_entradas') }}</h7>
                                </button>
                                <router-link 
                                    :to="getLinkTo()"
                                    v-else-if="productos"
                                    class="button large-button w-100"
                                >
                                    <span>
                                        {{ $t('eventos_productos.boton') }}
                                    </span>
                                </router-link>
                                <button v-else class="button red-content w-100" disabled>
                                    {{ $t('partidos.agotadas') }}
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </li>
</template>

<script setup>
    import { useEventoImagen } from '@/composables/front/events/useEventoImagen'
    import { getCurrentInstance, computed } from 'vue'
    import EventMetadata from "@/components/metadata/EventMetadata"
    import Countdown from '../../../common/Countdown'
    import RecordatorioModal from '@/views/frontend/events/layouts/index/modals/RecordatorioModal.vue'
    import BotonesPreventa from "../botones/BotonesPreventa"
    import { useMostrarPreventa } from '@/composables/front/events/preventa/useMostrarPreventa'

    const props = defineProps({
        event: {
            type: Object,
            required: true
        },
        productos: {
            type: Boolean,
            default: false
        }
    })

    // La card no conoce la fuente de datos de la lista que la contiene
    // (/eventos, /experiencias y /productos usan stores/acciones distintas).
    // Cuando expira el countdown delega la recarga en el padre vía @recargar,
    // igual que BotonesCompra.vue.
    const emit = defineEmits(['recargar']);

    const emitirRecargar = () => emit('recargar');

    const modal = getCurrentInstance().proxy.$modal;

    const { mostrarBotonesPreventa } = useMostrarPreventa(computed(() => props.event))

    const {
        fecha_actual,
        teatro,
        url,
        tieneGastosInternosOnline,
        toSlug,
        showModal,
        closeModal,
        getLinkTo
    } = useEventoImagen(props, modal)
</script>

<style scoped>
    li{
        border-radius: 16px;
    }

    li img {
        border-radius: 16px 16px 0 0;
    }

    .button {
        border-radius: 60px !important;
        height: 42px !important;
        justify-content: center !important;
        align-items: center !important;
        display: flex;
    }

    .btn-padding {
        padding: 20px;
    }

    .font-prox {
        font-size: 13px !important;
    }

    .price-hidden {
        visibility: hidden;
    }

    @media (max-width: 1024px) {
        .button {
            font-size: 12px !important;
        }
    }

    @media (max-width: 413px) {
        .p-responsive {
            padding: 35px !important;
        }
    }

    .red-content {
        background-color: #cc0000 !important;
        color: #ffffff !important;
        opacity: 0.65 !important;
        font-weight: bold !important;
    }
</style>